import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconCoverLetterSvg } from "./IconCoverLetterSvg.mjs";
const IconCoverLetter = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconCoverLetterSvg, ...svgProps }) });
export {
  IconCoverLetter
};
